import { OrderStreetAddressDetail } from '../UpdRelocationPlanDependant/UpdRelocationPlanDependant';

export function RelocationPlanDetails(){
    return {
        RelocationPlanID: 0,
        CaseID: 0,
        RankGainLocationID: 0,
        RankGainLocationDescription: null,
        GainBaseLocationDescription: null,
        GainBaseLocationID: 0,
        GainDutyLocationName: null,
        AdministrationBaseName: null,
        RelocationRequiredDate: null,
        PayGroup: null,
        Salary: 0,
        EnlistmentDate: null,
        IsTakingLeaveEnroute: false,
        DischargeAuthorityID: null,
        DischargeAuthority: null,
        DischargeDate: null,
        ReasonForRelocationID: 0,
        ReasonForRelocationCode: null,
        ReasonForRelocationSubTypeID: 0,
        ReasonForRelocationSubTypeCode: null,
        ReasonForRelocationDescription: null,
        ReasonForRelocationSubTypeDescription: null,
        PostingReceivedDate: null,
        PostingEffectiveDate: null,
        PromulgationDate: null,
        PostingTenure: null,
        PostingTenureID: null,
        ConcurrencyCheck: [],
        CaseConcurrencyCheck: [],
        Sensitive: false,
        ChosenToLeaveAccommodation: false,
        DeploymentSixMonthsOrLonger: false,
        ClosestDefenceLocationToGainingLocationID: 0,
        LocationArrivedInTasmaniaID: 0,
        ToBaseLocationDistanceToClosestDefenceLocation: 0,
        MemberIsTrainee: false,
        OrderSubTypeID: 0,
        Reserve: false,
        ForeignDefenceExchange: false,
        PriorEnlistmentAddress: OrderStreetAddressDetail,
        PostEnlistmentAddress: OrderStreetAddressDetail,
        GainUnitID: 0,
        GainAdminBaseID: 0,
        GainAdminUnitID: 0,
        PositionGainLocation: null,
        GainUnit: null,
        GainAdminBase: null,
        GainAdminUnit: null,
        CurrentState: 0

    }
}